<template>
  <div class="app-container">
    <!--    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
          <el-form-item label="危险源编码" prop="hazardCode">
            <el-input
                v-model="queryParams.hazardCode"
                placeholder="请输入危险源编码"
                clearable
                @keyup.enter.native="handleQuery"/>
          </el-form-item>
          <el-form-item label="任务" prop="taskId">
            <el-input
                v-model="queryParams.taskId"
                placeholder="请输入任务"
                clearable
                @keyup.enter.native="handleQuery"/>
          </el-form-item>
          <el-form-item label="检查日期" prop="checkDate">
            <el-date-picker clearable
                            v-model="queryParams.checkDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择检查日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>-->

    <el-row :gutter="10" class="mb8">
<!--      <el-col :span="1.5">
        <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd">新增
        </el-button>
      </el-col>-->
      <el-col :span="1.5">
        <el-button
            type="success"
            plain
            icon="el-icon-edit"
            size="mini"
            :disabled="single"
            @click="handleUpdate">修改
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
            type="danger"
            plain
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelete">删除
        </el-button>
      </el-col>
    </el-row>
    <div class="content">
      <el-table
          :data="specialDangerList"
          :header-cell-style="{ background: 'rgb(250,250,250)' }"
          style="width: 100%">
        <el-table-column type="selection" width="55" align="center"/>
        <el-table-column label="企业编码" align="center" prop="companyCode"/>
        <el-table-column label="隐患治理" align="center" prop="tbHiddenGovern.checkParts"/>
        <el-table-column label="任务编号" align="center" prop="taskId"/>
        <el-table-column label="检查类型" align="center" prop="checkType">
          <template slot-scope="scope">
            <el-link>{{ handleCheckType(scope.row.checkType) }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="检查项" align="center" prop="checkItemId"/>
        <el-table-column label="检查项评分细则" align="center" prop="checkScoreId"/>
        <el-table-column label="检查日期" align="center" prop="checkDate" width="180">
          <template slot-scope="{ row }">
            <span v-if="row.checkDate">{{ row.checkDate | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="罚款金额" align="center" prop="checkPay">
          <template slot-scope="{ row }">
            <el-link>{{ row.checkPay }} 元</el-link>
          </template>
        </el-table-column>
        <el-table-column label="危害类型" align="center" prop="harmType">
          <template slot-scope="{ row }">
            <el-link>{{ handleHarmType(row.harmType) }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)">修改
            </el-button>
            <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
      </div>
    </div>


    <!-- 添加或修改检查情况记录对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-form-item label="隐患治理" prop="dangerId">
          <el-select v-model="form.dangerId" placeholder="请选择隐患治理">
            <el-option
                v-for="dict in dangerList"
                :key="dict.id"
                :label="dict.checkParts"
                :value="dict.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务编号" prop="taskId">
          <el-input v-model="form.taskId" disabled="disabled"/>
        </el-form-item>
        <el-form-item label="检查类型" prop="checkType">
          <el-select v-model="form.checkType" placeholder="请选择检查类型" style="width: 100%">
            <el-option v-for="item in checkTypeArr"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="检查编号" prop="checkItemId">
          <el-input v-model="form.checkScoreId" disabled="disabled"/>
        </el-form-item>
        <el-form-item label="检查项评分细则编号" prop="checkScoreId">
          <el-input v-model="form.checkScoreId" disabled="disabled"/>
        </el-form-item>
        <el-form-item label="检查日期" prop="checkDate">
          <el-date-picker clearable
                          v-model="form.checkDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择辨识时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="罚款金额" prop="checkPay">
          <el-input v-model="form.checkPay" placeholder="请输入罚款金额"/>
        </el-form-item>
        <el-form-item label="危害类型" prop="harmType">
          <el-select v-model="form.harmType" placeholder="请选择危害类型" style="width: 100%">
            <el-option :value="1" label="事故类型"/>
            <el-option :value="2" label="火灾隐患"/>
          </el-select>
        </el-form-item>
        <el-form-item label="创建人" prop="creator">
          <el-input v-model="form.creator" placeholder="请输入创建人"/>
        </el-form-item>
        <el-form-item label="数据推送省厅" prop="isTest">
          <el-select v-model="form.isTest" style="width: 100%">
            <el-option :value="0" label="是"/>
            <el-option :value="1" label="否"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {listDangerGovern, listTask} from "@/api/specialExamination/task";
import {
  delSpecialDanger,
  getSpecialDanger,
  listSpecialDanger,
  updateSpecialDanger
} from "@/api/specialExamination/specialDanger"

export default {
  name: "Record",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      curPage: 1,
      pageSize: 10,
      // 检查情况记录表格数据
      specialDangerList: [],
      //隐患治理列表
      dangerList: [],
      //检查项任务
      taskList: [],
      //检查项信息
      checkItemList: [],
      //检查项评分细则
      checkScoreList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,

      checkTypeArr: [
        {label: "企业自查", value: 1},
        {label: "市级及以下检查", value: 2},
        {label: "省级检查", value: 3},
        {label: "部级检查", value: 4},
      ],
      harmTypeArr: [
        {label:"事故隐患",value:1},
        {label:"火灾隐患",value:2},
      ],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        recordId: null,
        companyCode: null,
        hazardCode: null,
        dangerId: null,
        taskId: null,
        checkType: null,
        checkItemId: null,
        checkScoreId: null,
        checkDate: null,
        checkPay: null,
        harmType: null
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {}
    };
  },
  created() {
    this.getList();
    // this.getTaskList();
    this.getDangerList();
  },
  methods: {
    pageChange(val) {
      this.curPage = val;
      this.getList();
    },
    /** 查询检查况记录列表 */
    getList() {
      this.loading = true;
      listSpecialDanger({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(response => {
        this.specialDangerList = response.body.data;
        this.total = response.body.cum
      });
    },
    getTaskList() {
      listTask().then(response => {
        //this.taskList = response.body.data;
      });
    },
    getDangerList() {
      this.componentsMoudel.startPost('/hiddenGovern/list', {}, true).then(res => {
        this.dangerList = res.body.data === null ? [] : res.body.data;
      })
    },
    handleCheckType(type) {
      let list = this.checkTypeArr.filter(item => item.value === type)
      return list[0].label
    },
    handleHarmType(type){
      let list = this.harmTypeArr.filter(item => item.value === type)
      return list[0].label
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        recordId: null,
        companyCode: null,
        hazardCode: null,
        dangerId: null,
        taskId: null,
        checkType: null,
        checkItemId: null,
        checkScoreId: null,
        checkDate: null,
        checkPay: null,
        harmType: null
      };
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.handleQuery();
    },

    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加检查况记录列表";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const recordId = row.recordId
      getSpecialDanger(recordId).then(response => {
        this.form = response.body.data;
        this.open = true;
        this.title = "修改检查况记录列表";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.recordId != null) {
            updateSpecialDanger(this.form).then(response => {
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作  */
    handleDelete(row) {
      delSpecialDanger(row.recordId).then(res => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
  }
};
</script>
